<div class="modal fade"  data-backdrop="static" [attr.id]="modalId" tabindex="-1" role="dialog" aria-labelledby="modalIdLabel">
  <div [class]="'modal-dialog modal-dialog-centered '+ size" role="document">
      <div class="modal-content">
         <ng-content select="[content]"></ng-content>
      </div>
  </div>
</div>
